import React from "react";
import {BrowserRouter as Router, Route, Link} from "react-router-dom";
import App from "./App";
import Profile from "./Profile";

function Index() {
    return <Profile/>;
}

function About() {
    return (

        <div className={"card-panel"}>
            <h2>About</h2>
            <p>
                Technology is changing many aspects of our working lives. Video interviews have become a very popular tool in recruitment process. You need to know the best way to prepare for this style of interview.
ivaluate helps you to showcase yourself and sell your skills and personality to a potential employer.

            </p>

            <iframe width="560" height="315" src="https://www.youtube.com/embed/jZ1MMVw1zxc" frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>


        </div>
    )
        ;
}

function Interview() {
    return <App/>;
}

function AppRouter() {
    return (
        <Router>
            <div>
                <nav className={"blue"}>
                    <ul>
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <Link to="/about/">About</Link>
                        </li>
                        <li>
                            <Link to="/practice/">Practice</Link>
                        </li>
                    </ul>
                </nav>

                <Route path="/" exact component={Index}/>
                <Route path="/about/" component={About}/>
                <Route path="/practice/" component={Interview}/>
            </div>
        </Router>
    );
}

export default AppRouter;